import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractSwitchesComponent} from 'app/core/switches.component';
import {
  SwitchCheckboxCollection,
  SwitchCollection,
  SwitchRadioCollection
} from 'app/entities/switchCollection.entity';

@Component({
  selector: 'app-chip-wrapper',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})

/**
 * Usage:
 * ```
 *     <app-chip-wrapper
 *       #chipWrapperComponent
 *       [items]="chipItems"
 *       [chipType]="'filter'"
 *       (emitChipClick)="onClickChip($event, chipWrapperComponent)"
 *     ></app-chip-wrapper>
 * ```
 *
 * Configurable params:
 *  - allowEmptySelection   - if `true`, chip can be 'unchecked' (similar to 'allowEmptySelection' param
 *                            of ion-radio-group). Relevant only if `chipType: 'radio'`.
 *  - chipType:
 *              `radio`     - act as radio switch;
 *              `checkbox`  - act as checkbox switch;
 *              `filter`    - (default) chips act as filter visualisation and have X button to remove them.
 *  - limit                 - if set to > 0, all chips above limit will be hidden under 'More' chip. Only works
 *                            with chipType: 'radio' | 'checkbox'
 */
export class ChipWrapperComponent extends AbstractSwitchesComponent<SwitchCheckboxCollection | SwitchRadioCollection> implements OnInit, OnDestroy {

  @Input() allowEmptySelection?: boolean = false;
  @Input() removeButton = false;
  @Input() limit = 0;   // won't work for chipType: 'filter'
  @Input() type?: 'radio' | 'checkbox';

  subs: any = [];

  moreKey = 'app-chip-more-key';
  moreSelected = false;

  moreCollection: SwitchCheckboxCollection = null;

  @Input() set collection(collection: (SwitchCheckboxCollection | SwitchRadioCollection)) {
    super.collection = collection;

    this.createMoreCollection();
  }

  get collection(): (SwitchCheckboxCollection | SwitchRadioCollection) {
    return this._collection;
  }

  ngOnInit() {
    this.createMoreCollection();
  }

  ngOnDestroy(): void {
    if (this.subs.length) {
      this.subs.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }

  onClick(event: any) {
    this.collection.itemSelect(event.detail.value);
  }

  onMoreClick(event) {
    const collectionOld = new SwitchCheckboxCollection(this.collection.items.slice(0, this.limit));

    this.appService.appModalService.openSelectModal(
      this.moreCollection,
      {
        type: 'checkbox',
        hideItemMark: false
      },
      (resultCollection: SwitchCheckboxCollection) => {
        if (resultCollection) {
          this.moreCollection = resultCollection;
          this.collection.itemSelect([...this.moreCollection.getSelectedId(), ...collectionOld.getSelectedId()] as any, true, true);
        }

      });
  }

  notifyValueChange(): void {
    super.notifyValueChange();
    this.createMoreCollection();
  }

  showMore() {
    return this.limit > 0 && this.collection.items.length > this.limit && !this.removeButton;
  }

  createMoreCollection() {
    if (this.showMore()) {
      this.moreCollection = new SwitchCheckboxCollection(this.collection.items.slice(this.limit));
    } else {
      this.moreCollection = null;
    }
  }

  removeItem(id: string, collection: SwitchCheckboxCollection | SwitchRadioCollection) {
    collection.itemSelect(id);
    if (this.collection instanceof SwitchCheckboxCollection) {
      this.collection.getConvertedSubCollectionToSwitchItem();
    }
  }
}
